export const setName = function(state, name) {
  state.user.name = name
}
export const setUserinfo = function(state, userinfo) {
  state.userinfo = userinfo
}


const handleDBHistoryDatas = function(datas, label) {
  let results = {
    dataFor7Days: {
      labels: [],
      datas: []
    },
    dataFor14Days: {
      labels: [],
      datas: []
    },
    dataFor30Days: {
      labels: [],
      datas: []
    }
  }
  for (let item in datas) {
    datas[item].forEach(element => {
      results[item].labels.push(element[label])
      results[item].datas.push(element.count)
    })
  }
  return results
}

export const setDBHistoryDatas = function(state, responses) {
  if (responses && responses.length === 2) {
    state.dashboard.orderDatas = responses[0]
    // state.dashboard.categoryDatas = handleDBHistoryDatas(responses[1], 'category')
    state.dashboard.productDatas = handleDBHistoryDatas(responses[1], 'sku')
  }
}



// WEBPACK FOOTER //
// ./src/vuex/mutation.js